import React from 'react';
import {
  PageHeader as StyledPageHeader,
  HeaderLeft,
  PageTitle,
  PageDescription,
  Controls,
  ViewToggle,
  ToggleButton,
  Select,
  Button,
} from '../PriceListsPage.style';
import { useTranslation } from 'react-i18next';

const SEASON_LABELS = {
  summer: 'summerTyres',
  winter: 'winterTyres',
  allSeason: 'allSeasonTyres',
};

const PageHeader = ({
  viewMode,
  onViewModeChange,
  selectedSeason,
  onSeasonChange,
  selectedBrand,
  onBrandChange,
  brands = [],
  seasons = [],
  onImportClick,
}) => {
  const { t } = useTranslation();

  return (
    <StyledPageHeader>
      <HeaderLeft>
        <PageTitle>{t('tyrePriceLists')}</PageTitle>
        <PageDescription>
          {t('priceListsDescription')}
        </PageDescription>
      </HeaderLeft>
      <Controls>
        <ViewToggle>
          <ToggleButton
            $active={viewMode === 'season'}
            onClick={() => onViewModeChange('season')}
          >
            {t('bySeason')}
          </ToggleButton>
          <ToggleButton
            $active={viewMode === 'brand'}
            onClick={() => onViewModeChange('brand')}
          >
            {t('byBrand')}
          </ToggleButton>
        </ViewToggle>
        
        {viewMode === 'season' ? (
          <Select
            value={selectedSeason}
            onChange={(e) => onSeasonChange(e.target.value)}
          >
            {seasons.map((season) => (
              <option key={season} value={season}>
                {t(SEASON_LABELS[season] || season)}
              </option>
            ))}
          </Select>
        ) : (
          <Select
            value={selectedBrand}
            onChange={(e) => onBrandChange(e.target.value)}
          >
            {brands.map((brand) => (
              <option key={brand} value={brand}>
                {brand}
              </option>
            ))}
          </Select>
        )}
        
        <Button $primary onClick={onImportClick}>
          <i className="mdi mdi-file-upload" />
          {t('importXlsx')}
        </Button>
      </Controls>
    </StyledPageHeader>
  );
};

PageHeader.displayName = 'PageHeader';

export default PageHeader;
